"use strict";
exports.__esModule = true;
var CHAT_ICON_TYPES = {
    DEFAULT: {
        label: 'Default',
        tooltip: '',
        type: 'default',
    },
    SMILE: {
        label: 'Smile',
        tooltip: '',
        type: 'smile',
    },
    HELP: {
        label: 'Help',
        tooltip: '',
        type: 'help',
    },
    TEXT: {
        label: 'Text',
        tooltip: 'Please choose a Max 4 Letter word/line. We only allow 2 Lines ',
        type: 'text',
    },
    IMAGE: {
        label: 'Image/GIF',
        tooltip: 'For an optimal experience, please choose an Image/gif that is 72px x 72px size and less than 5KB.',
        type: 'image',
    }
};
exports["default"] = CHAT_ICON_TYPES;
